module.exports = __webpack_public_path__ + "img/pageLineDesktop.c947e0a1.png";